var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-option-set", class: { inline: _vm.inline } },
    [
      !_vm.inline
        ? _c(
            "ul",
            _vm._l(_vm.options, function (ref) {
              var value = ref.value
              var label = ref.label
              var description = ref.description
              return _c(
                "li",
                { key: value },
                [
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": value },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    },
                    [
                      _c("p", [_vm._v(" " + _vm._s(label) + " ")]),
                      description
                        ? _c("p", { staticClass: "message" }, [
                            _vm._v(_vm._s(description)),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          )
        : _c(
            "div",
            { staticClass: "control" },
            _vm._l(_vm.options, function (ref) {
              var value = ref.value
              var label = ref.label
              return _c(
                "b-radio",
                {
                  key: value,
                  attrs: { "native-value": value },
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                },
                [_vm._v(" " + _vm._s(label) + " ")]
              )
            }),
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }